import { useEffect, useState } from 'react'
import * as sx from '../../common/stylesInline/report_daily_branch'
import Datepicker from '../../common/datePicker'
import DropDownOA from '../../common/dropDownOA'
import { Item } from '../../common/snippets'
import useToken from '../../helpers/useTokens'
import moment from 'moment'
import { Box, Stack, Button } from '@mui/material'
import { GetRequest } from '../../common/api'
import { urls } from '../../common/constants'
import { getCityBranchHeaders, getCriteriaHeaders, getExReportHeaders, getStatusList } from './constant'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { focusElemnt, isEmpty, navigation3 } from '../../common/helper'
import { CargoRoleRightsAtom } from '../../common/jotaiState/commonStateAtoms'
import { TableComponent } from '../../common/TableComponent'
import { DEMO_COMPANY, RAJESH_TRANSPORT } from '../../../helper/companyIdhardcode'
import { useTranslation } from '../../../i18n/I18nProvider'

export const ApprovedReport = () => {
  const { translations } = useTranslation()
  const op = translations?.operationsPrivilege || {}
  const cs = translations?.common || {}
  const statusList = getStatusList(translations)
  const criteriaHeaders = getCriteriaHeaders(translations)
  const { loginData } = useToken()
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const [fromDate, setFromDate] = useState(moment().format('YYYY-MM-DD'))
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
  const [cityList, setCityList] = useState([])
  const [branchList, setBranchList] = useState([])
  const [branchListFilter, setBranchListFilter] = useState([])
  const [userList, setUserList] = useState([])
  const [userListFilter, setUserListFilter] = useState([])
  const [city, setCity] = useState()
  const [branch, setBranch] = useState()
  const [user, setUser] = useState()
  const [status, setStatus] = useState(statusList[0])
  const [tableData, setTableData] = useState([])
  const [disableBtn, setDisableBtn] = useState(false)
  const { intCompanyID, IsBranchAdmin, IsMTPLAdmin, IsAdmin } = loginData
  const roleRights = useAtomValue(CargoRoleRightsAtom)
  const RoleRights = roleRights?.Table1?.[0] || {}
  const { AllowViewAllBranchReport, AllowViewAllBranchOfCityReport,AllowBranchInchargeRights } = RoleRights
  const enableBranchChange = AllowViewAllBranchReport || AllowViewAllBranchOfCityReport || IsBranchAdmin || IsMTPLAdmin || IsAdmin
  const enableCityChange = AllowViewAllBranchReport || IsBranchAdmin || IsMTPLAdmin || IsAdmin
  const headersList = [RAJESH_TRANSPORT, DEMO_COMPANY].includes(intCompanyID)
    ? [...getExReportHeaders(translations).slice(0, 2), ...getCityBranchHeaders(translations), ...getExReportHeaders(translations).slice(2)]
    : getExReportHeaders(translations)
  const headers = headersList.map((col) => ({
    ...col,
    align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
    exportHead: col.headerName,
    header: col.headerName,
  }))
  useEffect(() => {
    focusElemnt('goBtn')
  }, [])
  useEffect(() => {
      if (!isEmpty(roleRights) && !isEmpty(loginData)) {
        setDisableBtn(!(AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin))
      }
    }, [roleRights, loginData])
  const handleGo = async () => {
    const obj = {
      CompanyID: intCompanyID,
      BranchID: 0,
      CityID: 0,
      UserID: 0,
      FromDate: fromDate,
      ToDate: toDate,
      Mode: 3,
    }
    setLoader(true)
    GetRequest(urls.getExpenseEntryDetails + '?', obj)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || op.requestFailed || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error(cs.noDataFound || 'No Data Found')
        }
        const temp = res.Data.Table || []
        const { cityList, branchList, userList } = temp.reduce(
          (acc, item) => {
            if (!acc.citySet.has(item.CityID)) {
              acc.citySet.add(item.CityID)
              acc.cityList.push({
                id: item.CityID,
                name: item.CityName,
              })
            }
            if (!acc.branchSet.has(item.BranchID)) {
              acc.branchSet.add(item.BranchID)
              acc.branchList.push({
                id: item.BranchID,
                name: item.BranchName,
                CityID: item.CityID,
              })
            }
            if (!acc.userSet.has(item.UserID)) {
              acc.userSet.add(item.UserID)
              acc.userList.push({
                id: item.UserID,
                name: item.UserName,
                CityID: item.CityID,
                BranchID: item.BranchID,
              })
            }
            return acc
          },
          {
            cityList: [],
            branchList: [],
            userList: [],
            citySet: new Set(),
            branchSet: new Set(),
            userSet: new Set(),
          }
        )
        const allCity = { id: 0, name: cs.all || 'All' }
        const allBranch = { id: 0, name: cs.all || 'All', CityID: 0 }
        const allUser = { id: 0, name: cs.all || 'All', CityID: 0, BranchID: 0 }

        const cityData = [allCity, ...cityList]
        const branchData = [allBranch, ...branchList]
        const userData = [allUser, ...userList]

        setCityList(cityData)
        setBranchList(branchData)
        setUserList(userData)

        setBranchListFilter(branchData)
        setUserListFilter(userData)
        const ownCity =
          cityList.find(
            (x) => x.id === loginData.intBranchCityID
          ) || cityList[0]

        const ownBranch =
          branchList.find(
            (x) => x.id === loginData.intBranchID
          ) || branchList[0]

        const ownUser =
          userList.find(
            (x) => x.id === loginData.intUserID
          ) || userList[0]

        setCity(ownCity)
        setBranch(ownBranch)
        setUser(ownUser)
      })
      .catch((err) => {
        setAlert({
          show: true,
          msg: err.message,
          nextId: '',
        })
      })
      .finally(() => setLoader(false))
  }
  const handleLoad = () => {
    fetchData()
  }
  const fetchData = async () => {
    if (!city || !branch || !user) {
      setAlert({ show: true, msg: op.pleaseSelectCityBranchUser || 'Please select city, branch and user', nextId: '' })
      return
    }
    const obj = {
      CompanyID: intCompanyID,
      BranchID: branch?.id,
      CityID: city?.id,
      UserID: user?.id,
      FromDate: fromDate,
      ToDate: toDate,
      Mode: 3,
    }
    setLoader(true)
    GetRequest(urls.getExpenseEntryDetails + '?', obj)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || op.requestFailed || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table1) || res.Data.Table1.length === 0) {
          throw new Error(cs.noDataFound || 'No Data Found')
        }
        const temp = res.Data.Table1.filter((item) => item.Status === status.apiValue).map((item, index) => {
          return {
            ...item,
            [headers[0].field]: index + 1,
            dataType: 'entry',
          }
        })
        if (temp.length) {
          const totalAmount = temp.reduce((acc, item) => acc + item.ExpenseAmount, 0)
          temp.push({
            [headers[0].field]: cs.total || 'Total',
            dataType: 'total',
            align: { [headers[0].field]: 'right' },
            colSpan: { [headers[0].field]: headers.findIndex((header) => header.field === 'ExpenseAmount') },
            ExpenseAmount: totalAmount,
          })
        }
        setTableData(temp)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const criteriaData = {
    fromDate: fromDate,
    toDate: toDate,
    selCity: city?.name || '',
    selBranch: branch?.name || '',
    user: user?.name || '',
    status: status.name || '',
    dataType: 'entry',
  }
  return (
    <Box>
      <Stack direction="row" flexWrap="wrap" sx={{ padding: '10px 0', gap: '10px' }}>
        <Item sx={{ width: '18%', ...sx.itemsx }} className="input--container bookingDatePicker">
          <Datepicker
            label={op.selectFromDate || 'Select From Date'}
            id={'fromDateId'}
            dateChange={(date) => {
              setFromDate(date.format('YYYY-MM-DD'))
              focusElemnt('toDateId')
            }}
            width="100%"
          />
        </Item>
        <Item sx={{ width: '18%', ...sx.itemsx }} className="input--container bookingDatePicker">
          <Datepicker
            label={op.selectToDate || 'Select to Date'}
            id={'toDateId'}
            dateChange={(date) => {
              setToDate(date.format('YYYY-MM-DD'))
              focusElemnt('goBtn')
            }}
            width="100%"
          />
        </Item>
        <Button
          id="goBtn"
          className="select-lr-btn"
          variant="contained"
          color="error"
          style={{ backgroundColor: '#fe5200', fontSize: '1.3rem' }}
          onClick={() => handleGo()}
          onKeyDown={(e) => navigation3(e, 'cityId', 'toDateId', handleGo)}
        >
          {cs.go || 'Go'}
        </Button>
        <Item sx={{ ...sx.itemsxGrow }}>
          <DropDownOA
            label={op.selectCity || 'Select City'}
            id="cityId"
            nextId="branchId"
            prevId="goBtn"
            width="100%"
            data={cityList}
            dataKey="name"
            idKey="id"
            onSelect={(city) => {
              setCity(city)
              if (city.id === 0) {
                setBranchListFilter(branchList)
                setUserListFilter(userList)
                setBranch(branchList[0])
                setUser(userList[0])
                return
              }
              const branchFilter = branchList.filter(
                (item) => item.CityID === city.id || item.id === 0
              )
              const userFilter = userList.filter(
                (item) => item.CityID === city.id || item.id === 0
              )
              setBranchListFilter(branchFilter)
              setUserListFilter(userFilter)
              setBranch(branchFilter[1] || branchFilter[0])
              setUser(userFilter[1] || userFilter[0])
            }}
            defaultvalue={city?.name || ''}
            value={city?.name || ''}
            disabled={!enableCityChange || disableBtn}
          />
        </Item>
        <Item sx={{ ...sx.itemsxGrow }}>
          <DropDownOA
            label={op.selectBranch || 'Select Branch'}
            id="branchId"
            nextId="userId"
            prevId="cityId"
            width="100%"
            data={branchListFilter}
            dataKey="name"
            idKey="id"
            onSelect={(branch) => {
              setBranch(branch)
              if (branch.id === 0) {
                setUserListFilter(userList)
                setUser(userList[0])
                return
              }
              const userFilter = userList.filter(
                (item) =>
                  item.BranchID === branch.id || item.id === 0
              )
              setUserListFilter(userFilter)
              setUser(userFilter[1] || userFilter[0])
            }}
            defaultvalue={branch?.name || ''}
            value={branch?.name || ''}
            disabled={!enableBranchChange || disableBtn}
          />
        </Item>
        <Item sx={{ ...sx.itemsxGrow }}>
          <DropDownOA
            label={op.selectUser || 'Select User'}
            id="userId"
            nextId="statusId"
            prevId="branchId"
            width="100%"
            data={userListFilter}
            dataKey="name"
            idKey="id"
            onSelect={setUser}
            defaultvalue={user?.name || ''}
            value={user?.name || ''}
            disabled={!enableBranchChange}
          />
        </Item>
        <Item sx={{ ...sx.itemsxGrow }}>
          <DropDownOA
            label={op.selectStatus || 'Select Status'}
            id="statusId"
            nextId="loadBtn"
            prevId="userId"
            width="100%"
            data={statusList}
            dataKey="name"
            idKey="id"
            onSelect={setStatus}
            defaultvalue={status?.name || ''}
            value={status?.name || ''}
            disabled={disableBtn}
          />
        </Item>
        <Item sx={{ ...sx.itemsx }}>
          <Button
            id="loadBtn"
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
            onClick={() => handleLoad()}
            onKeyDown={(e) => navigation3(e, 'fromDateId', 'statusId', handleLoad)}
          >
            {cs.load || 'Load'}
          </Button>
        </Item>
      </Stack>
      {tableData.length ? (
        <TableComponent
          reportName={op.expenseApprovedReport || 'Expense Approved Report'}
          criteriaHeaders={criteriaHeaders}
          criteriaData={[criteriaData]}
          tableData={tableData}
          mainHeader={headers}
        />
      ) : (
        <></>
      )}
    </Box>
  )
}
